import { motion } from "framer-motion";
import { MenuSectionData } from "../../../utils/sections";

/*
 * The top level of the menu hierarchy: section -> category -> sub-category.
 *
 * These are the merchandising groups curated in the dashboard's Sections page,
 * which until now the storefront had no way to read.
 */
const SectionStrip = ({
  sections,
  activeId,
  onSelect,
}: {
  sections: MenuSectionData[];
  activeId: string | null;
  onSelect: (id: string | null) => void;
}) => {
  if (!sections.length) return null;

  const Tab = ({
    label,
    selected,
    onClick,
  }: {
    label: string;
    selected: boolean;
    onClick: () => void;
  }) => (
    <motion.button
      type="button"
      onClick={onClick}
      whileTap={{ scale: 0.95 }}
      aria-pressed={selected}
      className={`px-4 py-2.5 rounded-xl text-xs sm:text-sm font-bold whitespace-nowrap
        border transition-colors duration-150
        ${
          selected
            ? "bg-headingColor border-headingColor text-white shadow-md"
            : "bg-btnOverlay border-black/5 text-headingColor hover:border-headingColor/40"
        }`}
    >
      {label}
    </motion.button>
  );

  return (
    <div className="w-full flex flex-wrap items-center justify-center gap-2 sm:gap-3 px-2">
      <Tab
        label="Everything"
        selected={activeId === null}
        onClick={() => onSelect(null)}
      />
      {sections.map((section) => (
        <Tab
          key={section.id}
          label={section.header || "Section"}
          selected={activeId === section.id}
          onClick={() => onSelect(section.id)}
        />
      ))}
    </div>
  );
};

export default SectionStrip;
